import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '@core/services/token.service';

@Component({
    selector: 'app-redirect-token',
    templateUrl: './redirect-token.component.html',
    styleUrls: ['./redirect-token.component.scss'],
})
export class RedirectTokenComponent implements OnInit {
    constructor(private route: ActivatedRoute, private router: Router, private tokenService: TokenService) {}

    ngOnInit(): void {
        const token = this.route.snapshot.queryParamMap.get('token');
        const path = this.route.snapshot.queryParamMap.get('path');

        if (token) {
            this.tokenService.redirectToken(token).subscribe((response) => {
                this.router.navigate([path]);
            });
        }
    }
}
